import get from 'lodash/get';
import {
  CARD_FILTER_MODAL_OPENED,
  CARD_FILTER_MODAL_CLOSED,
  FLYER_FILTER_MODAL_OPENED,
  FLYER_FILTER_MODAL_CLOSED,
} from '../redux/modals';

import type { EventTracking, Store } from '../types';
import type {
  FilterGroup,
  FiltersModalInteractedAction,
  SelectSortAction,
  ToggleFilterAction,
} from '../types/filters';

import { getActiveFilters } from '../utils/selectors/filters';

/** @type {ActionType} */
export const pbr_filters_opened = 'pbr_filters_opened';

/** @type {ActionType} */
export const pbr_filters_opened_flyers = 'pbr_filters_opened_flyers';

/** @type {ActionType} */
export const pbr_filters_finished = 'pbr_filters_finished';

/** @type {ActionType} */
export const pbr_filters_finished_flyers = 'pbr_filters_finished_flyers';

/** @type {ActionType} */
export const pbr_select_sort = 'pbr_select_sort';

/** @type {ActionType} */
export const pbr_toggle_filter = 'pbr_toggle_filter';

/** @type {ActionType} */
export const pbr_toggle_filter_flyers = 'pbr_toggle_filter_flyers';

function stringifyActiveFilters(filters: FilterGroup[]): string {
  return JSON.stringify(getActiveFilters(filters));
}

function selectSort(action: SelectSortAction, state: Store) {
  const filterSelectionType = get(action, 'payload.filterSelectionType');

  return {
    selected_filters: stringifyActiveFilters(
      get(state, `filters.${filterSelectionType}.filterGroups`, ''),
    ),
    sort_value: get(action, 'payload.sortName', 'Most Popular'),
  };
}

function toggleFilter(action: ToggleFilterAction, state: Store) {
  const { type, value, toTurnOn, filterSelectionType } = action.payload;

  return {
    selected_filters: stringifyActiveFilters(
      get(state, `filters.${filterSelectionType}.filterGroups`, ''),
    ),
    filter_type: type,
    filter_value: value,
    filter_on: toTurnOn,
    sort_value: get(state, `filters.${filterSelectionType}.sort`, ''),
  };
}

function filtersModalInteracted(
  action: FiltersModalInteractedAction,
  state: Store,
) {
  const filterSelectionType = get(action, 'payload.filterSelectionType');
  const actionButtonName = get(action, 'payload.actionButtonName');

  return {
    id: actionButtonName,
    selected_filters: stringifyActiveFilters(
      get(state, `filters.${filterSelectionType}.filterGroups`, ''),
    ),
    sort_value: get(state, `filters.${filterSelectionType}.sort`, ''),
  };
}

const tracking: EventTracking = {};
tracking[CARD_FILTER_MODAL_OPENED] = filtersModalInteracted;
tracking[CARD_FILTER_MODAL_CLOSED] = filtersModalInteracted;
tracking[FLYER_FILTER_MODAL_OPENED] = filtersModalInteracted;
tracking[FLYER_FILTER_MODAL_CLOSED] = filtersModalInteracted;
tracking[pbr_select_sort] = selectSort;
tracking[pbr_toggle_filter] = toggleFilter;
tracking[pbr_toggle_filter_flyers] = toggleFilter;

export default tracking;
